export const productCardConstants = {
  CHOOSE_CURRENT_PRODUCT_REQUEST: 'CHOOSE_CURRENT_PRODUCT_REQUEST',
  CHOOSE_CURRENT_PRODUCT_SUCCESS: 'CHOOSE_CURRENT_PRODUCT_SUCCESS',
  CHOOSE_CURRENT_PRODUCT_FAILURE: 'CHOOSE_CURRENT_PRODUCT_FAILURE',
};
